import DataResponse from "@/models/data-response";
import ErrorResponse from "@/models/error-response";
import {ApiConfig, Endpoint, HeaderRequest} from "@/models/api-config";
import axios from "axios";

export class Request {
    baseURL: string;
    headers: HeaderRequest;
    endpoint:Endpoint;

    constructor(config: ApiConfig, endpoint: Endpoint) {
        this.endpoint = endpoint;
        this.baseURL = config.baseURL;
        this.headers = config.headers;
    }

    send(): Promise<DataResponse | ErrorResponse> {
        return axios({
            method: this.endpoint.method,
            url: `${this.baseURL}/${this.endpoint.url}`.replace(/\/$/, ''),
            withCredentials: true,
            headers: this.headers.toObject(),
            data: this.endpoint.dataRequest
        }).then(response => {
            return new DataResponse({...response})
        }).catch(error => {
            const status = error.status;
            const response = error.response;
            const message = response?.statusText || response?.data?.error?.message || "";
            const detail = response?.data?.error?.detail || "";
            return new ErrorResponse(status, message, detail)
        })
    }
}